module.exports = __webpack_public_path__ + "media/images/Checkmark-confirmation-98fdeb08.svg";